<template>
  <section class="sqsm">
    <div class="sqsm__wrap">
      <h2 class="sqsm__title">SI  QUIERES SABER MÁS</h2>

      <div class="sqsm__grid">
        <a
          v-for="(item, i) in items"
          :key="i"
          class="sqsm__card"
          :href="item.href"
          :target="item.external ? '_blank' : null"
          :rel="item.external ? 'noopener' : null"
          :aria-label="item.label"
        >
          <img
            :src="baseUrl(`images/svgs/${item.icon}.svg`)"
            :alt="item.label"
            class="sqsm__icon"
          />
          <span class="sqsm__text">{{ item.label }}</span>
        </a>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "InfoHelpGrid",
  props: {
    phone: { type: String, default: "+56 2 2994 9850" },
  },
  data() {
    return {
      items: [
        { label: "Conoce todos los programas", href: "https://www.preupdv.cl/programas", external: true, icon: "link" },
        { label: "Preguntas frecuentes", href: "https://www.preupdv.cl/preguntas-frecuentes", external: true, icon: "contact_support" },
        { label: "Formulario de contacto", href: "https://www.preupdv.cl/contacto", external: true, icon: "message" },
      ],
    };
  },
  methods: {
    baseUrl(path) {
      const base = process.env.BASE_URL || "/";
      return path.startsWith("/") ? path : base + path.replace(/^\/+/, "");
    },
  },
};
</script>
<style scoped>
.sqsm {
  padding: 40px 16px 56px;
  background: #fff;
  color: #0f172a;
  font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial;
}

/* Contenedor un poco más ancho para que entre el label largo */
.sqsm__wrap {
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  padding: 0 16px;
}

.sqsm__title {
  font-size: clamp(20px, 4vw, 24px);
  font-weight: 800;
  text-align: center;
  margin-bottom: 28px;
  color: #0b0b0b;
  line-height: 1.2;
}

.sqsm__grid {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  justify-content: center;    
  align-items: stretch;
}

/* Card alargada */
.sqsm__card {
  display: flex;
  align-items: center;
  gap: 12px;               
  padding: 16px 20px;        
  min-height: 64px;
  flex: 1 1 280px;
  max-width: 100%;
  min-width: 240px;
  border: 2px solid #e5e7eb;
  border-radius: 16px 36px 16px 16px;
  background: #fff;
  text-decoration: none;
  color: inherit;
  transition: border-color .2s ease, box-shadow .2s ease, transform .06s ease;
}

.sqsm__card:hover { 
  border-color: #cbd5e1; 
  box-shadow: 0 6px 24px rgba(2,6,23,.06); 
}

.sqsm__card:active { 
  transform: translateY(1px); 
}

.sqsm__card:focus { 
  outline: none; 
  box-shadow: 0 0 0 3px rgba(59,130,246,.35); 
}

/* Icono un poco más chico para ganar espacio */
.sqsm__icon {
  width: 22px;
  height: 22px;
  flex-shrink: 0;
}

/* Texto en una sola línea, más compacto */
.sqsm__text {
  font-size: clamp(14px, 3.5vw, 19px);
  font-weight: 500;
  color: #0b1220;
  letter-spacing: -0.2px;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
}

/* ===== RESPONSIVE DESIGN ===== */

/* Mobile Small (320px - 480px) */
@media (max-width: 480px) {
  .sqsm {
    padding: 24px 12px 40px;
  }
  
  .sqsm__wrap {
    padding: 0 12px;
  }
  
  .sqsm__title {
    font-size: 18px;
    margin-bottom: 20px;
  }
  
  .sqsm__grid {
    gap: 12px;
  }
  
  .sqsm__card {
    padding: 14px 16px;
    min-height: 56px;
    flex: 1 1 100%;
    min-width: 100%;
    border-radius: 12px 24px 12px 12px;
  }
  
  .sqsm__icon {
    width: 20px;
    height: 20px;
  }
  
  .sqsm__text {
    font-size: 14px;
  }
}

/* Mobile Medium (481px - 767px) */
@media (min-width: 481px) and (max-width: 767px) {
  .sqsm {
    padding: 32px 16px 48px;
  }
  
  .sqsm__wrap {
    padding: 0 16px;
  }
  
  .sqsm__title {
    font-size: 20px;
    margin-bottom: 24px;
  }
  
  .sqsm__grid {
    gap: 14px;
  }
  
  .sqsm__card {
    padding: 16px 18px;
    min-height: 60px;
    flex: 1 1 240px;
    min-width: 220px;
  }
  
  .sqsm__icon {
    width: 22px;
    height: 22px;
  }
  
  .sqsm__text {
    font-size: 15px;
  }
}

/* Tablet (768px - 1023px) */
@media (min-width: 768px) and (max-width: 1023px) {
  .sqsm {
    padding: 36px 20px 52px;
  }
  
  .sqsm__wrap {
    padding: 0 20px;
    max-width: 700px;
  }
  
  .sqsm__title {
    font-size: 22px;
    margin-bottom: 26px;
  }
  
  .sqsm__grid {
    gap: 18px;
  }
  
  .sqsm__card {
    padding: 18px 22px;
    min-height: 68px;
    flex: 1 1 300px;
    min-width: 260px;
  }
  
  .sqsm__icon {
    width: 24px;
    height: 24px;
  }
  
  .sqsm__text {
    font-size: 16px;
  }
}

/* Desktop (1024px+) */
@media (min-width: 1024px) {
  .sqsm {
    padding: 40px 24px 56px;
  }
  
  .sqsm__wrap {
    padding: 0 24px;
    max-width: 600px;
  }
  
  .sqsm__title {
    font-size: 24px;
    margin-bottom: 28px;
  }
  
  .sqsm__grid {
    gap: 20px;
  }
  
  .sqsm__card {
    padding: 18px 24px;
    min-height: 68px;
    flex: 1 1 320px;
    min-width: 280px;
  }
  
  .sqsm__icon {
    width: 24px;
    height: 24px;
  }
  
  .sqsm__text {
    font-size: 17px;
  }
}

/* Large Desktop (1280px+) */
@media (min-width: 1280px) {
  .sqsm__wrap {
    max-width: 700px;
  }
  
  .sqsm__grid {
    gap: 24px;
  }
  
  .sqsm__card {
    padding: 20px 26px;
    min-height: 72px;
    flex: 1 1 340px;
    min-width: 300px;
  }
  
  .sqsm__text {
    font-size: 18px;
  }
}

/* Extra Large Desktop (1440px+) */
@media (min-width: 1440px) {
  .sqsm__wrap {
    max-width: 800px;
  }
  
  .sqsm__card {
    flex: 1 1 360px;
    min-width: 320px;
  }
}

/* Landscape Mobile */
@media (max-height: 500px) and (orientation: landscape) {
  .sqsm {
    padding: 20px 16px 32px;
  }
  
  .sqsm__title {
    margin-bottom: 20px;
  }
  
  .sqsm__card {
    min-height: 52px;
    padding: 12px 18px;
  }
}

/* High DPI displays */
@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
  .sqsm__card {
    border-width: 1px;
  }
}

/* Print styles */
@media print {
  .sqsm {
    background: white;
    padding: 20px;
  }
  
  .sqsm__card {
    border: 1px solid #ccc;
    box-shadow: none;
  }
}
</style>


